var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4665_38849)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-721 -307)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -346,
    y: -132,
    width: 1521,
    height: 881,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4665_38849)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -322,
    y: -67,
    width: 1473,
    height: 342,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -322,
    y: -1,
    width: 1472,
    height: 52,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -321.5,
    y: -66.5,
    width: 1472,
    height: 341,
    rx: 9.5,
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4665_38849)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -721,
    y: -218,
    width: 1920,
    height: 991,
    fill: "black",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4665_38849)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -107,
    y: -136,
    width: 692,
    height: 827,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -82.5,
    y: -15.5,
    width: 643,
    height: 39,
    rx: 7.5,
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -71,
    y: -8,
    width: 87,
    height: 24,
    rx: 6,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59977 8.09977L1.25 0.75",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 8.09977L8.59977 0.75",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4665_38849",
    x: -741,
    y: -238,
    width: 1960,
    height: 1031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4665_38849"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4665_38849",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4665_38849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(-721 -307)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4665_38849"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -322,
    y: -67,
    width: 1473,
    height: 342,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4665_38849"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -107,
    y: -136,
    width: 692,
    height: 827,
    rx: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSvg);
export default __webpack_public_path__ + "static/media/crossSVG.799ca4f4ca33fca475c3065d025e7f80.svg";
export { ForwardRef as ReactComponent };